import {PiHandWaving, PiMicrophone, PiDiscoBall, PiArrowRight} from 'react-icons/pi';
import {GiMeltingIceCube} from 'react-icons/gi';
import {TbBowling} from 'react-icons/tb';
import {CiCircleCheck} from 'react-icons/ci';

// Shared by the event diagram and the movable ordering cards.
export const STAGE_ICONS = {
  welcome:PiHandWaving, introduction:PiMicrophone, icebreaker:GiMeltingIceCube,
  'first-activity':PiDiscoBall, transition:PiArrowRight,
  'second-activity':TbBowling, closing:CiCircleCheck,
};

